var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "common-content",
    [
      _c(
        "div",
        { staticClass: "us-show" },
        _vm._l(_vm.pageData, function(context) {
          return context.type === "1"
            ? _c("div", { key: context.id }, [
                _c("img", { attrs: { src: context.mainImg, alt: "" } })
              ])
            : _vm._e()
        }),
        0
      ),
      _c("page-title", { attrs: { pageName: _vm.pageName } }),
      _c(
        "div",
        { staticClass: "us-text" },
        _vm._l(_vm.pageData, function(context) {
          return _c("div", { key: context.id }, [
            context.type === "1"
              ? _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.reads(context.content)) }
                })
              : _vm._e(),
            context.type === "1"
              ? _c(
                  "div",
                  _vm._l(context.imgList, function(item) {
                    return _c("div", [
                      _c("img", { attrs: { src: item.url, alt: "" } })
                    ])
                  }),
                  0
                )
              : _vm._e()
          ])
        }),
        0
      ),
      _c("page-title", { attrs: { pageName: _vm.dev } }),
      _c("div", { staticClass: "us-develop" }, [
        _c(
          "ul",
          [
            _vm._l(_vm.descPageData, function(item, index) {
              return [
                item.type === "2"
                  ? _c("li", { staticClass: "us-develop_par" }, [
                      _c("span", { staticClass: "us-develop_time" }, [
                        _vm._v(_vm._s(item.title))
                      ]),
                      _c("span", { staticClass: "us-develop_describe" }, [
                        _vm._v(_vm._s(item.content))
                      ])
                    ])
                  : _vm._e()
              ]
            })
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd6af9cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd6af9cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/us/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cd6af9cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/us/index.vue
// module chunks = 7